import React from 'react';
import { isCountdownAvailable } from '../../helpers';
import StartStatusBadge, { InternalRegStatusBadge } from '../../common/StartStatusBadge';
import CountDownBadge from '../../common/CountDown/CountDownBadge';
import { CardMedia } from '../../common/Card';
import style from './index.scss';

export default ({
    image,
    status,
    displayCountdown,
    countdownType,
    isRegInternal,
    ...countDown
}) => (
    <CardMedia className={style.media} image={image}>
        <div className={style.mediaContent}>
            <div className={style.badgesContainer}>
                <StartStatusBadge status={status} />
                {isRegInternal && <InternalRegStatusBadge />}
            </div>
            {isCountdownAvailable(status, displayCountdown, countdownType) &&
            <CountDownBadge className={style.countdown} status={status} {...countDown} />}
        </div>
    </CardMedia>
);
